export async function readFiles(e: Event): Promise<FileList | null> {
  if (!e.target) return null;

  const target = e.target as HTMLInputElement;
  if (!target.files || target.files.length === 0) return null;

  return target.files;
}
